export const calculatePageSize = (): number => {
    return Math.ceil(((window.innerHeight - 310)) / 70)
  }